import { render, staticRenderFns } from "./form-view.vue?vue&type=template&id=252448aa&scoped=true&"
import script from "./form-view.vue?vue&type=script&lang=js&"
export * from "./form-view.vue?vue&type=script&lang=js&"
import style0 from "./form-view.vue?vue&type=style&index=0&id=252448aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252448aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/pjabang/projects/taybull-ui/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VForm,VLayout})
